/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_All_ItemsInputs */



/**
* | output |
* | --- |
* | "All calendar items" |
*
* @param {Agenda_Filter_All_ItemsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_all_items = /** @type {((inputs?: Agenda_Filter_All_ItemsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_All_ItemsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alle agenda-items")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les éléments de l’agenda")
	return /** @type {LocalizedString} */ ("All calendar items")
});